import React from "react";
import { capitalizeWords, isArabic } from "../../../utils/util";
import DirhamSymbol from "../../../common/DirhamSymbol";

const PaymentHistoryCard = ({
  status = "success",
  date = "12/03/2024",
  refno = "45432524",
  salmaRequestNo = "843234",
  amount = 120,
  translationMap
}) => {

  const formatDate = (dateString) => {
    let local = "en-GB";

    const date = new Date(dateString);
    const day = date.toLocaleString(local, { day: '2-digit' });
    const month = date.toLocaleString(local, { month: 'long' });
    const year = date.toLocaleString(local, { year: 'numeric' });
    const time = date.toLocaleString(local, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    return `${day} ${month} ${year} ${time}`;
  };

  if (status && isArabic()) {
    status = translationMap?.[status.toLowerCase()] || status;
  }

  return (
    <div className="Payment_Status_Box">
            <div className="btn_box">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#">
                  {isArabic() ?
                    <>{amount}<DirhamSymbol width={9} height={10} marginTop={0} /></> :
                    <><DirhamSymbol width={9} height={10} marginTop={0} />{amount}</>
                  }
                </a>
            </div>
            <div className="content_box">
                <div className="inner_box1">
                    <p>
                        <b>{translationMap?.paymentStatus}</b>
                        {capitalizeWords(status)}
                    </p>
                    <p>
                        <b>{translationMap?.paymentDate}</b>
                        <span style={{ direction: "ltr" }}> {formatDate(date)}</span>
                    </p>
                </div>
                <div className="inner_box1">
                    <p>
                        <b>{translationMap?.referenceNumber}</b>
                        {refno}
                    </p>
                    <p>
                        <b>{translationMap?.requestNumber}</b>
                        {salmaRequestNo}
                    </p>
                </div>
            </div>
        </div>);

};

export default PaymentHistoryCard;